export { default } from './VisuallyHiddenSpan';
